import { render } from "./CreateProjectModal.vue?vue&type=template&id=f947f85e&scoped=true"
import script from "./CreateProjectModal.vue?vue&type=script&lang=js"
export * from "./CreateProjectModal.vue?vue&type=script&lang=js"

import "./CreateProjectModal.vue?vue&type=style&index=0&id=f947f85e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f947f85e"]])

export default __exports__